<template>
  <b-modal
    hide-footer
    id="modal-personal"
    ref="modal-personal"
    size="xl"
    title="เพิ่มข้อมูล"
  >

    <b-row>
      <b-col md="3">
        <b-form-group
          label="เลขบัตรประชาชน*"
          label-for="identity"
        >

          <b-form-input
            id="identity"
            v-model="personal.identity"
            placeholder="เลขบัตรประชาชน"
            :formatter="formatIdentity"
            @blur="onBlurIdentity"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="ชื่อ"
          label-for="name"
        >

          <b-form-input
            id="name"
            v-model="personal.name"
            placeholder="ชื่อ"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="นามสกุล"
          label-for="lastname"
        >

          <b-form-input
            id="lastname"
            v-model="personal.lastname"
            placeholder="นามสกุล"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="วันเดือนปี เกิด"
          label-for="dateOfBirth"
        >
          <b-form-datepicker
            id="dateOfBirth"
            v-model="personal.dateOfBirth"
            placeholder="วันเดือนปี เกิด"
            v-bind="languages || {}"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="th"
            :hide-header="false"
            today-button
            reset-button
            close-button
          />

        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
          label="ที่อยู่"
          label-for="address"
        >

          <b-form-textarea
            id="address"
            v-model="personal.address"
            placeholder="ที่อยู่"
          />
        </b-form-group>
      </b-col>




      <b-col md="3">
        <b-form-group
          label="ตำบล"
          label-for="tumbol"
        >


            <vue-autosuggest
              v-model="personal.tumbol"
              :suggestions="filteredOptions"
              @focus="focusMe"
              @click="clickHandler"
              @input="onInputChange"
              @selected="onSelected"
              @blur="onBlured"
              
              :input-props="{id:'autosuggest__input', placeholder:'ตำบล',class: 'form-control' }">
              <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                <!-- <img :style="{ display: 'flex', width: '25px', height: '25px', borderRadius: '15px', marginRight: '10px'}" :src="suggestion.item.avatar" /> -->
                <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.label}}</div>
              </div>
            </vue-autosuggest>



        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="อำเภอ"
          label-for="ampher"
        >

          <b-form-input readonly
            id="ampher"
            v-model="personal.ampher"
            placeholder="อำเภอ"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="จังหวัด"
          label-for="province"
        >

          <b-form-input readonly
            id="province"
            v-model="personal.province"
            placeholder="จังหวัด"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="รหัสไปรษณีย์"
          label-for="zipcode"
        >

          <b-form-input readonly
            id="zipcode"
            v-model="personal.zipcode"
            placeholder="รหัสไปรษณีย์"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="เบอร์โทรศัพท์"
          label-for="mobile"
        >

          <b-form-input
            id="mobile"
            v-model="personal.mobile"
            placeholder="เบอร์โทรศัพท์"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="อีเมล"
          label-for="email"
        >

          <b-form-input
            id="email"
            v-model="personal.email"
            placeholder="อีเมล"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="LineID"
          label-for="line"
        >

          <b-form-input
            id="line"
            v-model="personal.line"
            placeholder="LineID"
          />
        </b-form-group>
      </b-col>

      <b-col
        md="3"
        class="d-flex justify-content-center"
      >
        <b-button
          variant="outline-primary"
        >
          อ่านข้อมูลจากบัตร
        </b-button>
      </b-col>

    </b-row>

    <footer id="modal-personal___BV_modal_footer_" class="modal-footer">
      <button type="button" class="btn btn-primary" block @click="modalLocalSave">บันทึก</button>
    </footer>

  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BFormTextarea,
  BFormDatepicker

} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { VueAutosuggest } from 'vue-autosuggest';
import * as ComplaintAPI from '@/store/api/complaint/complaint.js'
import * as lang from 'vuejs-datepicker/src/locale'

export default {
  components: {
    BRow,
    BCol,
    BFormDatepicker,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    VueAutosuggest,
    ComplaintAPI,
    lang
  },
  data() {
    return {
      query: "",
      selected: "",
      selectedtumbol: "",
      languages: lang.th,
    };
  },
  props: {
    personal: {
      type: Object,
    },
    suggestions: {
      type: Array,
    },
  },
  computed: {
    identityState(){
      return this.personal.identity.length === 13 ? true : false
    },
    // nameState(){
    //   return this.personal.name ? true : false
    // },
    // lastnameState(){
    //   return this.personal.lastname ? true : false
    // },
    // dateOfBirthState(){
    //   return this.personal.dateOfBirth ? true : false
    // },
    // addressState(){
    //   return this.personal.address ? true : false
    // },
    // tumbolState(){
    //   return this.personal.tumbol ? true : false
    // },
    // mobileState(){
    //   return this.personal.mobile ? true : false
    // },
    // emailState(){
    //   return this.personal.email ? true : false
    // },
    // lineState(){
    //   return this.personal.line ? true : false
    // },


    
    filteredOptions() {

      return [
        { 
          data: (this.suggestions[0].data.filter(option => {
            return option.label.includes(this.selectedtumbol)
          })).slice(0,10)
        }
      ];
    }
  },
  methods: {
    requiredState(obj){
      console.log("obj:",obj)
      return true;
    },
    onBlurIdentity(){
      var self = this;
      ComplaintAPI.getbyidentity(this.personal.identity).then(function (response) {

          //console.log('getbyidentity:', response.data.message);
          if(response.data.message =="success" && response.data.data.length>0){
            var obj = response.data.data[0];
            console.log('successData:', obj);

            self.personal.name = obj.fName;
            self.personal.lastname = obj.lName;
            self.personal.dateOfBirth = obj.birthDate;
            self.personal.address = obj.address1;

            self.personal.tumbol = obj.tumbon;
            self.selectedtumbol = obj.tumbon;//auto suggest handle

            self.personal.tumbolcode = obj.tumbonCode;
            self.personal.ampher = obj.ampher;
            self.personal.amphercode = obj.ampherCode;
            self.personal.province = obj.province;
            self.personal.provincecode = obj.provinceCode;
            self.personal.zipcode = obj.zipcode;

            self.personal.mobile = obj.tel;
            self.personal.email = obj.email;



            obj.contacts.every(o => {
              if(o.contactTypeId == 4)
              {
                self.personal.line = o.description;
                return false;
              }
              else return true;
            })


          }



          
          })
          .catch(function (error) {
          })
          .then(function () {

          });

    },
    getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
      },
      formatIdentity(e){
        return String(e).substring(0,13);
      },
      modalLocalSave() {

          //calculate age
          this.personal.age = this.getAge(this.personal.dateOfBirth);
          //calculate age

          
        if(this.personal.identity.length === 13
            // && this.personal.name.length > 0
            // && this.personal.lastname.length > 0
            // && this.personal.dateOfBirth.length > 6
            // && this.personal.address.length > 0
            // && this.personal.tumbol.length > 0
            // && this.personal.ampher.length > 0
            // && this.personal.province.length > 0
            // && this.personal.zipcode.length > 0
            // && this.personal.mobile.length > 0
            // && this.personal.email.length > 0
            // && this.personal.line.length > 0
        ) {
          this.$emit('ModalLocalSave', this.personal, this.personal.type)
          this.$refs['modal-personal'].hide()
        }else{
          alert("โปรดระบุข้อมูลให้ครบทุก Field")
        }
      },
      
      clickHandler(item) {
  // event fired when clicking on the input
        console.log("clickHandler: ",item)
      },
      onSelected(item) {
        this.personal.tumbol=""; //แก้ bug lib ชื่อเหมือนเดิมแล้วค่าไม่เปลี่ยน
        var self = this;
        this.selected = item.item;
        ComplaintAPI.GetAddressBySubDistrictName(item.item.value).then(function (response) {

          //console.log('then222', response);
 
          if(response.data.success == true)
          {

            self.personal.tumbol=response.data.data.subDistrictName;
            self.personal.tumbolcode=response.data.data.subDistrictCode;
            self.personal.ampher=response.data.data.districtName;
            self.personal.amphercode=response.data.data.districtCode;
            self.personal.province=response.data.data.provinceName;
            self.personal.provincecode=response.data.data.provinceCode;
            self.personal.zipcode=response.data.data.zipcode;
          }
          else{
            self.personal.tumbol="";
            self.personal.tumbolcode="";
            self.personal.ampher="";
            self.personal.amphercode="";
            self.personal.province="";
            self.personal.provincecode="";
            self.personal.zipcode="";
          }


          
          })
          .catch(function (error) {
            self.personal.tumbol="";
            self.personal.tumbolcode="";
            self.personal.ampher="";
            self.personal.amphercode="";
            self.personal.province="";
            self.personal.provincecode="";
            self.personal.zipcode="";
          })
          .then(function () {
            // always executed
            //console.log('GET2')
          });
        


        console.log('onSelected', this.selectedtumbol) 
      },
      onBlured(){
          var self = this;

          ComplaintAPI.GetValidateTumbolName(this.personal.tumbol).then(function (response) {

          //console.log('then333', response);
 
          if(response.data.success == true){
          
          }
          else{
            self.personal.tumbol="";
            self.personal.tumbolcode="";
            self.personal.ampher="";
            self.personal.amphercode="";
            self.personal.province="";
            self.personal.provincecode="";
            self.personal.zipcode="";
          }


          
          })
          .catch(function (error) {
            self.personal.tumbol="";
            self.personal.tumbolcode="";
            self.personal.ampher="";
            self.personal.amphercode="";
            self.personal.province="";
            self.personal.provincecode="";
            self.personal.zipcode="";
          })
          .then(function () {
            // always executed
            //console.log('GET3')
          });



        console.log('onBlured', this.selectedtumbol) 
      },
      onInputChange(text) {
        this.selectedtumbol = text;
        console.log("onInputChange:",text)
      },
      /**
       * This is what the <input/> value is set to when you are selecting a suggestion.
       */
      // getSuggestionValue(suggestion) {

      //   console.log("getSuggestionValue:",suggestion)
      //   return suggestion.item.label;
      // },
      focusMe(e) {
        console.log("focusMe:",e) // FocusEvent
      },
  },
  created() {
    console.log('created', this)
  },
}
</script>

<style>
.demo { 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* input {
  width: 260px;
  padding: 0.5rem;
}

ul {
  width: 100%;
  color: rgba(30, 39, 46,1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}
li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
li:hover {
  cursor: pointer;
} */

.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}

#autosuggest { width: 100%; display: block;}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178,0.2);
}
</style>
